import en from './_en.js'

export default {
  en
}
